import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import H5 from 'UIComponents/elements/headings/H5';
import UIScrollContainer from 'UIComponents/scroll/UIScrollContainer';
import { GREAT_WHITE } from 'HubStyleTokens/colors';
import { INNER_CARD_BORDER_RADIUS, INNER_CARD_PADDING } from 'developer-docs-shared-components/config/cssConstants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ParamWrapper = styled.div.withConfig({
  displayName: "EndpointParameters__ParamWrapper",
  componentId: "a4o5u7-0"
})(["padding-top:", "px;border:1px solid ", ";border-radius:", "px;"], INNER_CARD_PADDING, GREAT_WHITE, INNER_CARD_BORDER_RADIUS);

// TODO: Implement empty state
const EndpointParameters = ({
  children
}) => {
  return /*#__PURE__*/_jsxs(ParamWrapper, {
    className: "params",
    children: [/*#__PURE__*/_jsx(H5, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "developer-docs-shared-components.params.header.parameters"
      })
    }), /*#__PURE__*/_jsx(UIScrollContainer, {
      children: /*#__PURE__*/_jsx("div", {
        className: "params-block",
        children: children || /*#__PURE__*/_jsx("div", {
          className: "no-params",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "developer-docs-shared-components.params.body.noParams"
          })
        })
      })
    })]
  });
};
export default EndpointParameters;